<div class="container layout-vbox" style="overflow: auto">
    <h4>
        Tables
        <fluent-button appearance="stealth" (click)="listTables()">
            <i class="fas fa-sync"></i>
        </fluent-button>
    </h4>

    <div style="width: 100%; flex: 1; overflow: hidden">
        <wj-flex-grid #grid style="height: 100%" [isReadOnly]="true" headersVisibility="Column" selectionMode="Row"
                      (dblclick)="onRowDoubleClick($event)"
            >
            <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="100"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Sheet Name'" [binding]="'worksheet.name'" [width]="150"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'Address'" [binding]="'_range.address'" [width]="150"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'#Rows'" [binding]="'rows.count'"></wj-flex-grid-column>
            <wj-flex-grid-column [header]="'#Cols'" [binding]="'columns.count'"></wj-flex-grid-column>
        </wj-flex-grid>
    </div>

    <div class="toolbar">
        <fluent-button appearance="accent">Show</fluent-button>
    </div>
</div>
